module.exports = __webpack_public_path__ + "media/images/squadBet__iconSwap-b8e933b545325e381738637fa4ee66d5.png";